/**
 * Normalized project status for display in portfolio views.
 *
 * Demo portfolio accounts (CompagnyMeta.ShowDemoProjects === true) present
 * their demo projects as if they were active, so the dashboard card and the
 * projects overview aren't empty during demos.
 *
 * @param {{ Status?: string | null }} project - CompagnyMeta document of the project
 * @param {boolean} showDemoAsActive - The tenant's ShowDemoProjects flag
 * @returns {string} Lowercased status; 'demo' becomes 'active' when the flag is on
 */
const effectiveProjectStatus = (project, showDemoAsActive) => {
    const status = (project?.Status || '').toLowerCase()
    return showDemoAsActive && status === 'demo' ? 'active' : status
}

export default effectiveProjectStatus
